module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_asakusa-3b59ae3f17d7fa80e61275ad0d683dc1.jpg";